import React from 'react'
import PropTypes from 'prop-types'
import * as validation from '../../utils/validation'
import { todayDateTime, todayISODateOff } from '../../utils/datesTimes'
import { getOrderNo, saveOrder } from '../../Firebase/apiAccount'
import { resolveOrder } from '../../config/account'
import { DEFAULT, NOT_SET } from '../../config/accountSubscription'
import Loader from '../Controls/Loader'
import RadioInput from './RegisterFormRadioInput'
import TextBox from './RegisterFormTextBox'
import CheckBox from './RegisterFormCheckBox'
import './RegisterForm.css'
import './RegConfirmation.css'
import RegDataTable from './RegDataTable'

class RegisterForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      nameOk: true,
      addressOk: true,
      icoOk: true,
      dicOk: true,
      emailOk: true,
      acceptConditionOk: true,
      validate: false,
      progress: false,
      summary: false,
      prevSubscriptionChanged: false
    }
    this.handleSummary = this.handleSummary.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.checkState = this.checkState.bind(this)
    this.checkStateSingle = this.checkStateSingle.bind(this)
  }

  handleSummary(summary) {
    if (this.checkState()) {
      if (summary) {
        let { regData } = this.props
        if (regData.subscription === NOT_SET) {
          regData.subscription = DEFAULT
          this.props.onChange(regData)
        }
      }
      this.setState({
        summary: summary
      })
    } else {
      this.setState({
        validate: true
      })
    }
  }

  handleSubmit () {
    this.setState({
      progress: true
    })
    getOrderNo(orderNo => {
      const { prevSubscriptionChanged } = this.state
      const regData = {
        ...this.props.regData,
        date: todayDateTime(),
        orderNo: orderNo,
        dueDate: todayISODateOff(10),
        prevSubscription: prevSubscriptionChanged ? this.state.prevSubscription : this.props.regData.subscription
      }
      this.props.onChange(regData)
      const accounState = resolveOrder(this.props.accountState)
      saveOrder(regData, accounState, () => {
        this.setState({
          progress: false
        })
        this.props.onSubmit(accounState)
      }, (error) => {
        // TODO:
        console.log(error)
      })
    })
  }

  handleChange (e) {
    let regData = this.props.regData
    if (e.stateProp === 'subscription' && !this.state.prevSubscriptionChanged) {
      this.setState({
        prevSubscriptionChanged: true,
        prevSubscription: regData.subscription
      })
    }
    regData[e.stateProp] = e.value
    this.props.onChange(regData)
    if (!this.state.validate) {
      return
    }
    this.checkStateSingle(e.stateProp, e.value)
  }

  checkState () {
    const { name, address, ico, dic, email, acceptCondition } = this.props.regData
    const nameOk = validation.validateNotEmpty(name)
    const addressOk = validation.validateNotEmpty(address)
    const icoOk = ico ? validation.validateIco(ico) : true
    const dicOk = dic ? validation.validateDic(dic) : true
    const emailOk = validation.validateEmail(email)
    const acceptConditionOk = acceptCondition
    this.setState({
      nameOk: nameOk,
      addressOk: addressOk,
      icoOk: icoOk,
      dicOk: dicOk,
      emailOk: emailOk,
      acceptConditionOk: acceptConditionOk
    })
    return nameOk && addressOk && icoOk && dicOk && emailOk && acceptConditionOk
  }

  checkStateSingle (stateProp, value) {
    switch (stateProp) {
      case 'name':
      case 'address':
        const statePropOk = stateProp + 'Ok'
        this.setState({
          [statePropOk]: validation.validateNotEmpty(value)
        })
        break
      case 'ico':
        this.setState({
          icoOk: value ? validation.validateIco(value) : true
        })
        break
      case 'dic':
        this.setState({
          dicOk: value ? validation.validateDic(value) : true
        })
        break
      case 'email':
        const statePropEOk = stateProp + 'Ok'
        this.setState({
          [statePropEOk]: validation.validateEmail(value)
        })
        break
      case 'acceptCondition':
        this.setState({
          acceptConditionOk: value
        })
        break
      default:
    }
  }

  render () {
    const {subscription, name, address, ico, dic, acceptCondition, email} = this.props.regData
    if (!this.state.summary) {
      const {nameOk, addressOk, icoOk, dicOk, emailOk, acceptConditionOk } = this.state
      return (
        <div className='ua-co'>
          <h3>{this.props.title}</h3>
          <RadioInput stateProp='subscription' value={subscription < 0 ? DEFAULT : subscription} onChange={this.handleChange}/>
          <TextBox label='Jméno/název' value={name} stateProp='name'
            onChange={this.handleChange} autoFocus ok={nameOk} />
          <TextBox label='Adresa/Sídlo' value={address} stateProp='address'
            onChange={this.handleChange} ok={addressOk} />
          <div className='ua-ic-co'>
            <TextBox label='IČO' value={ico} stateProp='ico'
              onChange={this.handleChange} size='8' ok={icoOk} />
            <TextBox label='DIČ' value={dic} stateProp='dic'
              onChange={this.handleChange} size='12' ok={dicOk} />
          </div>
          <TextBox label='E-mail pro zasílání faktur' value={email} stateProp='email'
            onChange={this.handleChange} ok={emailOk} />
          <CheckBox label={<span>Souhlas s<a href='https://dadopa.cz/doc/op1' target='blank' className='ua-lin'>
            Obchodními podmínkami</a></span>} marginTop='2rem'
            value={acceptCondition} stateProp='acceptCondition'
            onChange={this.handleChange} ok={acceptConditionOk} />
          <div className='ua-lin-con'>
            <a href='https://dadopa.cz/doc/zou2' target='blank' className='ua-lin'>Zásady ochrany osobních údajů</a>
          </div>
          <button className='ua-bu but-hig' onClick={() => this.handleSummary(true)}>Shrnutí objednávky</button>
        </div>
      )
    } else {
      return (
        <div className='cf-con'>
          <h3 className='cf-h3'>Shrnutí objednávky</h3>
          <RegDataTable regData={this.props.regData}/> 
          <button className='but-hig' onClick={this.handleSubmit}>Objednat</button>
          <button className='ua-bu' onClick={() => this.handleSummary(false)}>Upravit údaje</button>
          {this.state.progress ? <Loader /> : null}
        </div>
      )
    }
  }
}

RegisterForm.propTypes = {
  accountState: PropTypes.string,
  regData: PropTypes.object,
  title: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func
}

export default RegisterForm



// WEBPACK FOOTER //
// ./src/components/UserAccount/RegisterFormC.js